import { connect } from 'react-redux';
import { validateBusinessPhoneNumber } from './business.actions';
import { AppState } from '../app/app.types';
import BusinessRegisterComponent from './register.component';
import { BusinessRegisterRequest } from '../admin/signup.types';
import { AddressInfo, AddressInfoError } from '../geo/address.types';

type OwnProps = {
  readonly businessRegisterRequestHandler: (request: BusinessRegisterRequest) => void
  readonly businessRegisterRequest: BusinessRegisterRequest
  readonly addressInfo: AddressInfo
  readonly addressInfoError: AddressInfoError
  readonly addressInfoHandler: (addressInfo: AddressInfo) => void
  readonly onBusinessLogoImageFileHandler: (fileFormatError: string, fileSizeError: string, newImageFile: File) => void
  readonly fileSizeError: string
};

const mapDispatchToProps = (dispatch, ownProps: OwnProps) => {
  return {
    validateBusinessPhoneNumber: (phone: string) => dispatch(validateBusinessPhoneNumber(phone)),
    businessRegisterRequestHandler: ownProps.businessRegisterRequestHandler,
    businessRegisterRequest: ownProps.businessRegisterRequest,
    addressInfo: ownProps.addressInfo,
    onBusinessLogoImageFileHandler: ownProps.onBusinessLogoImageFileHandler,
    fileSizeError: ownProps.fileSizeError
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    signupState: state.signupState,
    businessState: state.businessState
  };
};

const BusinessRegister: React.ComponentClass<OwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(BusinessRegisterComponent);

export default BusinessRegister;



// WEBPACK FOOTER //
// ./src/business/register.tsx